<template>
    <v-card
        id="signin-page"
        color="transparent"
        flat
        tile
        class="mx-auto mt-16"
        max-width="400"
    >
        <v-card-title class="d-flex justify-center pb-0">
            <div class="text--blue">
                Welcome To
            </div>
        </v-card-title>
        <div class="d-flex justify-center">
            <LocatorLogixLogo />
        </div>
        <v-card-text>
            <div class="d-flex justify-center app-name pb-0">
                Sign In
            </div>
            <div class="signin-alert-container">
                <v-alert
                    v-show="showDominionNotice"
                    icon="error_outlined"
                    color="#CB3D31"
                    text
                    dense
                    type="error"
                >
                    <span style="font-weight: bold; font-size: 1.15em; text-transform: uppercase;">
                        NOTICE:
                    </span>
                    <span style="margin-left: 8px;">
                        Starting Wed Dec 17 at 2AM, <strong>Dominion SC</strong> users should login at 
                        <a href="https://e1.LocatorLogix.com" target="_blank">e1.LocatorLogix.com</a>.
                        Please update your bookmarks.
                    </span>
                </v-alert>

                <v-alert
                    v-show="incorrectLogin"
                    icon="error_outlined"
                    color="#CB3D31"
                    text
                    dense
                    type="error"
                >
                    {{ errorMessage }}
                </v-alert>
                <div v-if="isLoggingIn" class="d-flex justify-center text-center">
                    <v-progress-circular
                        left
                        indeterminate
                        class="ml-0"
                        color="gray"
                        size="16"
                        width="2"
                    />
                    <span class="mt-3">Logging in...</span>
                </div>
            </div>
            <v-form
                ref="signinForm" 
                v-model="formValid"
                style="margin-top: 3em;"
            >
                <v-text-field
                    id="username"
                    v-model="username"
                    class="custom-placeholer-color"
                    outlined
                    placeholder="Username"
                    prepend-inner-icon="person_outline"
                    :error="!!incorrectLogin"
                    :rules="usernameRules"
                    @keyup.enter="enterKeyPress"
                />
                <v-text-field
                    v-model="password"
                    class="custom-placeholer-color"
                    outlined
                    :type="showPassword ? 'text' : 'password' "
                    placeholder="Password"
                    prepend-inner-icon="lock_outline"
                    :error="!!incorrectLogin"
                    :rules="passwordRules"
                    @keyup.enter="enterKeyPress"
                >
                    <template v-slot:append>
                        <v-icon
                            class="material-icons-outlined"
                            :color="incorrectLogin ? 'red' : null"
                            @click="showPassword = !showPassword"
                        >
                            {{ getVisibilityIcon }}
                        </v-icon>
                    </template>
                </v-text-field>
                <div class="d-flex justify-space-between py-2">
                    <span>View the <a
                        href="/EULA-NORFIELD-DEVELOPMENT-PARTNERS-SAAS-TERMS.html"
                        target="_blank"
                    >Terms and Conditions</a></span>
                    <router-link to="/forgot-password">
                        Forgot Password?
                    </router-link>
                </div>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-row class="px-5">
                <v-btn
                    height="48px"
                    depressed
                    :dark="!isLoggingIn"
                    :color="isLoggingIn ? '#92A4C8' : '#122448'"
                    block
                    :disabled="isLoggingIn"
                    @click="signIn"
                >
                    Sign in
                </v-btn>
            </v-row>
        </v-card-actions>
        <v-card-actions class="mt-5">
            <v-row class="px-5">
                <v-btn
                    height="48px"
                    depressed
                    :dark="!isLoggingIn"
                    :color="isLoggingIn ? '#92A4C8' : '#122448'"
                    block
                    class="button is-dark is-large"
                    :disabled="isLoggingIn"
                    @click="AzureLogin"
                >
                    Sign in with Microsoft <img
                        class="ml-4"
                        src="../assets/mssymbol.svg"
                        alt="MS logo"
                    >
                </v-btn>
            </v-row>
        </v-card-actions>
        <v-row class="mt-5">
            <v-col class="text--secondary text-center">
                Powered by
                <img
                    src="../assets/logo.png"
                    width="100px"
                    style="display: inline-flex;vertical-align: middle;"
                >
            </v-col>
        </v-row>
    </v-card>
</template>
<script>
import webtmsBackend from '../services/webtmsBackend';
import LocatorLogixLogo from './CustomIcons/LocatorLogixLogoBlue';
import serviceWorkerManager from '../services/serviceWorkerManager';
import activeDirectory from '../auth/activeDirectory';

export default {
    components: {
        LocatorLogixLogo,
    },
    data: () => ({
        isLoggingIn: false,
        formValid: false,
        incorrectLogin: false,
        showPassword: false,
        showDominionNotice: false,
        errorMessage: '',
        username: '',
        password: '',
        usernameRules: [
            v => !!v || 'Username is required',
        ],
        passwordRules: [
            v => !!v || 'Password is required',
        ],
        user:{},
    }),
    computed: {
        getVisibilityIcon(){
            return this.showPassword ? 'visibility': 'visibility_off';
        }
    },
    mounted() {
        window.localStorage.clear();
        // Show Dominion Notice if current date is between 12/16/2025 10PM and 12/21/2025 12AM
        const now = new Date();
        const start = new Date('2025-12-16T22:00:00');
        const end = new Date('2025-12-21T00:00:00');
        this.showDominionNotice = now >= start && now < end;
    },
    async created() {
    
    },
    methods: {
        async signIn() {
            try {
                this.incorrectLogin = false;
                this.isLoggingIn = true;
                this.errorMessage = '';
                const loginResult = await webtmsBackend.login(this.username, this.password);
                if(loginResult === 'ERR - Invalid login!') {
                    this.errorMessage = 'Incorrect username or password.';
                    this.incorrectLogin = true;
                } else if(loginResult.user) {
                    await this.getUser(loginResult);                   
                }
            } catch(error) {
                this.errorMessage = error.message;
            } finally {
                this.isLoggingIn = false;
            }
        },
        enterKeyPress() {
            this.$refs.signinForm.validate();
            if(this.formValid) {
                this.signIn();
            }
        },
        async AzureLogin() {
            try {
                this.incorrectLogin = false;
                this.isLoggingIn = true;
                this.errorMessage = '';
                const response = await activeDirectory.signInWithAD();                
                if(response){
                    const user = response;                                      
                    
                    // Login to WebTMS
                    const loginResult = await webtmsBackend.loginSSO(user);

                    if (typeof loginResult === 'string' && loginResult.startsWith('ERR')) {
                        // Handle error case
                        this.errorMessage = 'Error while signing in with Microsoft <Auth>';
                        this.incorrectLogin = true;
                        console.error(loginResult, response);
                    } else if (typeof loginResult === 'object' && loginResult?.user) {
                        // Handle success case
                        await this.getUser(loginResult);
                    } else {
                        // Handle unexpected response
                        this.errorMessage = 'Unexpected response from loginSSO.';
                        this.incorrectLogin = true;
                        console.error('Unexpected loginResult:', loginResult);
                    }
                } else{
                    this.incorrectLogin = true;                               
                    this.errorMessage = 'Error while signing in with Microsoft <signIn>';
                }                                   
            }  catch(error) {
                this.incorrectLogin = true;                               
                this.errorMessage = 'Error while signing in with Microsoft';
                console.log(error);                          
            } finally {
                this.isLoggingIn = false;
            }
        },
        async AzureLogout() {
            try {
                await activeDirectory.signOut(this.user.id);
                this.user = {};
            } catch (err) {
                this.error = err.toString();
            }
        },
        async getUser(loginResult) {
            try {
                const getUserResult = await webtmsBackend.getUserObject(loginResult.user.uid);
                this.$store.commit('SET_USER', getUserResult);

                this.$store.commit('SET_USER_OPTIONS', loginResult.userOptions);
                this.$store.commit('SET_USER_PERMISSIONS', loginResult.userPermissions);
                this.$store.commit('SET_USER_MESSAGES_VIEW', loginResult.userMessagesView);
                this.$store.commit('SET_COMPANY', loginResult.company);
                this.$store.commit('SET_COMPANY_OPTIONS', loginResult.companyOptions);
                this.$store.commit('SET_COMPANY_PERMISSIONS', loginResult.companyPermissions);
                this.$store.commit('SET_NAVBAR_MINI', true);
                this.$store.commit('SET_SYSTEM_VARIABLES', loginResult.systemVariables);
                this.$store.commit('SET_ONLINE_SINCE', new Date());

                this.$store.commit('SET_COMPANY_CENTERS', loginResult.companyCenters);
                this.$store.commit('SET_COMPANY_BILLING', loginResult.companyBilling);
                this.$store.commit('SET_COMPANY_MEMBER_CODES', loginResult.companyMemberCodes);
                this.$store.commit('SET_COMPANY_TICKET_PRIORITES', loginResult.companyTicketPriorities);
                this.$store.commit('SET_COMPANY_TICKET_TYPES', loginResult.companyTicketTypes);
                this.$store.commit('SET_COUNTIES', loginResult.counties);
                this.$store.commit('SET_COMPANY_USERS', loginResult.companyUsers);
                this.$store.commit('SET_COMPANY_USERS_DELETED', loginResult.companyUsersDeleted);
                this.$store.commit('SET_COLUMNS_CATALOG', loginResult.ticketColumnsCatalog);
                this.$store.commit('SET_COMPANY_RESPONSE_CODES', loginResult.companyResponseCodes);
                this.$store.commit('SET_CENTERS_RESPONSE_CODES', loginResult.centersPosRespCodes);
                this.$store.commit('SET_COMPANY_RESPONSE_MAP', loginResult.companyPositiveResponseMap);
                this.$store.commit('SET_USER_CLIPBOARD', loginResult.userClipboard);
                this.$store.commit('SET_COMPANY_LAYERS', loginResult.companyLayers);
                this.$store.commit('SET_COMPANY_TICKET_CATEGORIES', loginResult.companyTicketCategories);
                this.$store.commit('SET_CENTER', loginResult.centers);
                this.$store.commit('SET_USER_PERMISSIONS_CATALOG', loginResult.userPermissionsCatalog);
                this.$store.commit('SET_COMPANY_EMAIL_SUPPLEMENTAL', loginResult.companyEmailSupplemental);
                this.$store.commit('SET_REPORTS', loginResult.reportHistory);
                this.$store.commit('SET_SYS_REPORTS', loginResult.sysReports);

                if(this.$store.getters.offlineResponses.length) {
                    serviceWorkerManager.goOnline();
                }
                // Retrieve latest version of index.html from server (not from cache)
                await webtmsBackend.getNoCache(location.origin);
                // The browser will cache the result of the above call
                // and now we load the newly cached file
                if(this.$route.query.redirectTo) {
                    this.$router.push(this.$route.query.redirectTo);
                } else {
                    this.$router.push('/tickets');
                    location.assign(location.origin);
                }               
            } catch (err) {
                this.error = err.toString();
            }
        },
    },
};
</script>
<style >
.v-application #signin-page .custom-placeholer-color input::placeholder {
  color: rgba(0, 0, 0, 0.60)!important;
  opacity: 1;
}
.v-application #signin-page .custom-placeholer-color.error--text input::placeholder {
  color: red!important;
  opacity: 1;
}
#signin-page .logo-container {
    margin-bottom: 80px
}
#signin-page .app-name {
    font-family: Roboto;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 50px;
    letter-spacing: 0em;
    text-align: left;
    color: #35383F;
}
#signin-page .app-sub-title {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.0015em;
    color: #5F6470;
}
#signin-page .text--blue {
    color: #35383F;
}
#signin-page .signin-alert-container {
    height:80px;
}
</style>
